import {applyMiddleware, createStore} from "redux";
import thunk from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';
import masterReducer from "./../reducer/MasterReducer"

import {persistReducer, persistStore} from 'redux-persist'
import storage from 'redux-persist/lib/storage';
import {IS_AUTH} from "../action/type.action";


const persistConfig = {
    key: 'root',
    storage,
    whitelist: [IS_AUTH]
}
const persistedReducer = persistReducer(persistConfig, masterReducer)
const middleware = [thunk];


export const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(...middleware)));
export const persist = persistStore(store)


